import React from "react";
import Bold from "../MenuItems/Bold";
import Italic from "../MenuItems/Italic";
import Underline from "../MenuItems/Underline";
import Strikethrough from "../MenuItems/Strikethrough";
import Color from "../MenuItems/Color";

const BasicTextFormatting = ({ editor, disabled }) => {
	return (
		<>
			<div className={`editor-menu-box`}>
				<Bold
					onChange={() => editor.chain().focus().toggleBold().run()}
					isDisabled={
						disabled || !editor.can().chain().focus().toggleBold().run()
					}
					isActive={editor.isActive("bold")}
				/>
				<Italic
					onChange={() => editor.chain().focus().toggleItalic().run()}
					isDisabled={
						disabled || !editor.can().chain().focus().toggleItalic().run()
					}
					isActive={editor.isActive("italic")}
				/>
				<Underline
					onChange={() => editor.chain().focus().toggleUnderline().run()}
					isDisabled={
						disabled || !editor.can().chain().focus().toggleUnderline().run()
					}
					isActive={editor.isActive("underline")}
				/>
				<Strikethrough
					onChange={() => editor.chain().focus().toggleStrike().run()}
					isDisabled={
						disabled || !editor.can().chain().focus().toggleStrike().run()
					}
					isActive={editor.isActive("strike")}
				/>
				<Color
					onChange={color => editor.chain().focus().setColor(color).run()}
					value={editor.getAttributes("textStyle").color}
					disabled={disabled}
				/>
			</div>
			<style>{`
                .text-color {
                    border: none;
                    outline: none;
                    width: 20px;
                }
            `}</style>
		</>
	);
};

export default BasicTextFormatting;
